export default __webpack_public_path__ + "static/media/logo.8fe9bc37.svg";